import { Group, Loader } from "@mantine/core";
import React from "react";
import { useParams } from "react-router-dom";
import { useGetProjectByProjectIdChecklistAndChecklistIdPartsQuery } from "../../../../../openapi";
import { useAppSelector } from "../../../../hooks";
import { selectChecklistActiveTab, selectActiveChecklist, selectChecklistPartsArgs } from "../checklistSelectors";
import ChecklistBoardAgGridRefactored from "./ChecklistBoardAgGridRefactored";
import { ChecklistLogsTable as ChecklistLogsRefactored } from "./ChecklistLogsRefactored";
import ChecklistSettingsRefactored from "./ChecklistSettingsRefactored";

const EMPTY_CHECKLIST_PARTS_ARGS = {
  projectId: "",
  checklistId: "",
};

const ChecklistAppRefactored = () => {
  const { checklistId } = useParams<{ checklistId: string }>();
  const activeTab = useAppSelector(selectChecklistActiveTab);
  const checklist = useAppSelector((state) => selectActiveChecklist(state, checklistId));
  const checklistPartsArgs = useAppSelector((state) => selectChecklistPartsArgs(state, checklistId));
  const { isLoading, isFetching } = useGetProjectByProjectIdChecklistAndChecklistIdPartsQuery(
    checklistPartsArgs ?? EMPTY_CHECKLIST_PARTS_ARGS,
    {
      skip: checklistPartsArgs == null,
    },
  );

  if ((isLoading || isFetching) && checklist == null) {
    return (
      <Group justify="center" flex={1} p="xl">
        <Loader size="sm" />
      </Group>
    );
  }

  if (activeTab === "CHECKLIST") {
    return <ChecklistBoardAgGridRefactored />;
  }

  if (activeTab === "LOGS") {
    return <ChecklistLogsRefactored />;
  }

  if (activeTab === "SETTINGS") {
    return <ChecklistSettingsRefactored />;
  }

  return null;
};

export default ChecklistAppRefactored;
